import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {
    WB_FinishedProductRelationshipRow,
    WB_WorkflowStatusRow,
} from "../PA.Core/PAdbSchemaRows";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {BaseLnBO} from "./BaseLnBO";

export class BaseLnBOValidations{

    static ValidateEmptyFields(aBO: BaseLnBO): Promise<void> {

        return new Promise((resolve,error)=>{

            if (_.isEmpty(aBO.WB_BaseLn.cif.BASELINE_ID) || _.isNull(aBO.WB_BaseLn.cif.BASELINE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Baseline ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_BaseLn.cif.BASELINE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "Baseline Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            if (_.isEmpty(aBO.WB_BaseLn.cif.SOURCE_ID) || _.isNull(aBO.WB_BaseLn.cif.SOURCE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'sourceid',
                        type: MessageType.Error,
                        title: "Source ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('sourceid')
            }

            if (_.isEmpty(aBO.WB_BaseLn.cif.BASELINE_TYPE_ID) || _.isNull(aBO.WB_BaseLn.cif.BASELINE_TYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'baselinetype',
                        type: MessageType.Error,
                        title: "Baseline Type  ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('baselinetype')
            }

            if((aBO.WB_BaseLn.cif.WB_CUST_ID == 0) || _.isUndefined(aBO.WB_BaseLn.cif.WB_CUST_ID) || _.isNull(aBO.WB_BaseLn.cif.WB_CUST_ID)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'custid',
                        type: MessageType.Error,
                        title: "Customer ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('custid')
            }

            if((aBO.WB_BaseLn.cif.WB_PERIOD_ID == 0) || _.isUndefined(aBO.WB_BaseLn.cif.WB_PERIOD_ID) || _.isNull(aBO.WB_BaseLn.cif.WB_PERIOD_ID)){
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'period',
                        type: MessageType.Error,
                        title: "Period cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('period')
            }

            if (_.isEmpty(aBO.WB_BaseLn.cif.LOAD_STATUS_ID) || _.isNull(aBO.WB_BaseLn.cif.LOAD_STATUS_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'loadstatus',
                        type: MessageType.Error,
                        title: "Load Status ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('loadstatus')
            }

        resolve()
        })
    }


}